'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _RTE = require('../components/RTE');

var _RTE2 = _interopRequireDefault(_RTE);

var _ShareThis = require('../components/ShareThis');

var _ShareThis2 = _interopRequireDefault(_ShareThis);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StaticArticle = function () {
  function StaticArticle(section) {
    (0, _classCallCheck3.default)(this, StaticArticle);

    this.el = section.el;
    this.rteEls = this.el.querySelectorAll('.rte');
    this.rtes = [];

    for (var i = 0; i < this.rteEls.length; i++) {
      this.rtes.push(new _RTE2.default(this.rteEls[i]));
    }

    this.shareThisEl = this.el.querySelector('[data-sharethis]');

    if (this.shareThisEl) {
      this.sharethis = new _ShareThis2.default(this.shareThisEl);
    }
  }

  (0, _createClass3.default)(StaticArticle, [{
    key: 'onSectionUnload',
    value: function onSectionUnload() {
      this.rtes.forEach(function (rte) {
        return rte.unload();
      });

      if (this.shareThis) {
        this.sharethis.unload();
      }
    }
  }]);
  return StaticArticle;
}();

exports.default = StaticArticle;